import { DepositPayment } from './DepositPayment'

export enum DepositStatus {
    PendingPayment,
    Paid,
    Refunded,
}

export class Deposit {
    constructor(
        public id: string,
        public paymentMethodId: string | null,
        public amount: number,
        public currencyCode: string,
        public payments: DepositPayment[],
        public dateCreated: Date
    ) { }

    get status(): DepositStatus {
        if (!this.isPaid()) {
            return DepositStatus.PendingPayment
        }
        if (this.isRefunded()) {
            return DepositStatus.Refunded
        }
        return DepositStatus.Paid
    }

    isPaid(): boolean {
        return this.amountPaid() >= this.amount
    }

    isRefunded(): boolean {
        const paidAmount = this.amountPaid()
        if (paidAmount === 0) {
            return false
        }
        return this.amountRefunded() >= paidAmount
    }

    amountPaid(): number {
        return this.payments.reduce((sum, p) => sum + p.amount, 0)
    }

    amountRefunded(): number {
        return this.payments
            .reduce((sum, p) => sum + p.refundedAmount(), 0)
    }

    amountHeld(): number {
        return this.payments.reduce((total, payment) => total + payment.amountRefundable(), 0)
    }

    amountRefundable(): number {
        return this.payments.filter(payment => payment.paymentIntentId !== null)
            .reduce((total, payment) => total + payment.amountRefundable(), 0)
    }

    datePaid(): Date | null {
        if (this.payments.length === 0) {
            return null
        }
        return this.payments.reduce((latest, p) =>
            p.dateCreated > latest ? p.dateCreated : latest,
            this.payments[0].dateCreated
        )
    }

    dateRefunded(): Date | null {
        if (!this.isRefunded()) {
            return null
        }
        const refundedPayments = this.payments.filter(p => p.dateRefunded !== null)
        if (refundedPayments.length === 0) {
            return null
        }
        return refundedPayments.reduce((latest, p) =>
            p.dateRefunded! > latest ? p.dateRefunded! : latest,
            refundedPayments[0].dateRefunded!
        )
    }
}
